import { render, staticRenderFns } from "./ReserveDashboard.vue?vue&type=template&id=66551ed6&scoped=true"
import script from "./ReserveDashboard.ts?vue&type=script&lang=ts&external"
export * from "./ReserveDashboard.ts?vue&type=script&lang=ts&external"
import style0 from "./ReserveDashboard.vue?vue&type=style&index=0&id=66551ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66551ed6",
  null
  
)

export default component.exports